import MainComponent from "components/Main";
import PropTypes from 'prop-types';

import { ReactComponent as ArrowBig } from 'icons/components/arrowBig.svg';

import './index.less';
import './themes/default.less';

export default class ControlDate extends MainComponent {
    static propTypes = {
        doctor: PropTypes.object,
        days: PropTypes.number,
        value: PropTypes.instanceOf(Date),
        onChange: PropTypes.func
    };

    static defaultProps = {
        doctor: {},
        days: 1,
        value: "",
        onChange: null
    };

    changeDay(flag) {
        const { value, days, doctor } = this.props;

        if (doctor?.id)
            flag *= days;

        const newDate = this._helper.date.addDays(value, flag);

        if (this.props.onChange)
            this.props.onChange(newDate);
    }

    insertArrow(isLeft = true) {
        const flag = isLeft ? -1 : 1;
        const cl = isLeft ? "rotate180" : "";

        return (
            <div className="blockArrow flex centerAll rad4 hand" onClick={this.changeDay.bind(this, flag)}>
                <ArrowBig className={cl} />
            </div>
        );
    }

    formatText() {
        const { value, doctor, days } = this.props;

        if (doctor?.id) {
            const value2 = this._helper.date.addDays(value, days - 1);

            return (
                <>
                    {this.tr("main.schFor")}
                    &nbsp;
                    {this._helper.string.formatFullName(doctor, "short")}
                    &nbsp;
                    {this.tr("main.from")}
                    &nbsp;
                    {this._helper.date.toStr(value, "D.MM.YYYY")}
                    &nbsp;
                    {this.tr("main.to")}
                    &nbsp;
                    {this._helper.date.toStr(value2, "D.MM.YYYY")}
                </>
            );
        }

        return this._helper.date.toTodayStr(value, "D MMMM YYYY");
    }

    render() {
        return (
            <div className="controlDate">
                <div className="blockSelectDate flex">
                    {this.insertArrow()}
                    {this.insertArrow(false)}
                    <div className="flex centerV text blockTitle">
                        {this.formatText()}
                    </div>
                </div>
            </div>
        );
    }
}
